import React from 'react';
import type {ThesaurusNodeDetailsCodeValue as GrepDetailsCodeValueType} from 'services/thesaurus/types';
import {useGrepNodeDetailsList} from '../hooks';
import {ThesaurusNodeDetailsRelated} from './ThesaurusNodeDetailsRelated';

type Props = {
  itemKey: string;
  value: GrepDetailsCodeValueType;
};

export const GrepDetailsCodeValue: React.FC<Props> = ({itemKey, value}) => {
  const nodes = useGrepNodeDetailsList(value.value);
  return nodes.status === 'Loaded' ? (
    <ThesaurusNodeDetailsRelated label={itemKey} related={nodes.data} />
  ) : null;
};
